/**
 * tabSitzung — schützt vor vermischten Anmeldungen zwischen Browser-Tabs.
 *
 * Die Anmeldung (Token + Benutzer) liegt im localStorage und gilt für alle Tabs desselben Browsers.
 * Meldet man sich in einem Tab als anderer Benutzer an (oder ab), zeigt ein bereits offener Tab noch
 * die Daten des bisherigen Kontos, schickt seine Anfragen aber schon mit dem neuen Token – Daten
 * würden so im falschen Mandanten gespeichert. Deshalb merkt sich jeder Tab, mit welchem Benutzer er
 * geladen wurde. Weicht der Browser-Benutzer davon ab, werden Anfragen blockiert (services/api.js)
 * und der Tab wird gesperrt, bis er neu geladen wird (components/SitzungGewechseltHinweis.jsx).
 */
export const SITZUNG_GEWECHSELT_EVENT = 'easywork:sitzung-gewechselt';

let tabBenutzer = null; // { id, name } des Benutzers, mit dem dieser Tab arbeitet

const anzeigeName = (u) => (u ? [u.first_name, u.last_name].filter(Boolean).join(' ') || u.email || '' : '');

/** Aus AuthContext aufrufen, sobald dieser Tab einen Benutzer an- oder abmeldet. */
export function tabBenutzerSetzen(user) {
  tabBenutzer = user?.id ? { id: user.id, name: anzeigeName(user), email: user.email || '' } : null;
}

export function browserBenutzer() {
  try {
    const u = JSON.parse(localStorage.getItem('user') || 'null');
    return u?.id ? { id: u.id, name: anzeigeName(u), email: u.email || '' } : null;
  } catch {
    return null;
  }
}

/** Liefert { tab, browser }, wenn der Browser inzwischen mit einem anderen Konto (oder gar nicht) angemeldet ist. */
export function sitzungsKonflikt() {
  if (!tabBenutzer) return null;
  const browser = browserBenutzer();
  if (browser && browser.id === tabBenutzer.id) return null;
  return { tab: tabBenutzer, browser };
}

export function sitzungsKonfliktMelden() {
  const konflikt = sitzungsKonflikt();
  if (konflikt) window.dispatchEvent(new CustomEvent(SITZUNG_GEWECHSELT_EVENT, { detail: konflikt }));
  return konflikt;
}

// Anmeldung in einem anderen Tab → storage-Event (feuert nur in den übrigen Tabs)
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === null || e.key === 'user' || e.key === 'token') sitzungsKonfliktMelden();
  });
}
